export default {"src":"/_next/static/media/podcast-profile-dark.2d8f99ea.svg","height":100,"width":100};